(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const setupMobileCarousel = () => {
      const mobileView = document.querySelector('.mobile-view');
      if (!mobileView || window.getComputedStyle(mobileView).display === 'none') return;

      const carousel = mobileView.querySelector('.testimonial-sliders-mobile');
      if (!carousel || carousel.dataset.initialized === 'true') return;
      
      let slides = Array.from(carousel.querySelectorAll('.testimonial-card'));
      if (slides.length === 0) return;

      carousel.querySelectorAll('.clone').forEach(clone => clone.remove());
      
      slides = Array.from(carousel.querySelectorAll('.testimonial-card:not(.clone)'));

      const firstClone = slides[0].cloneNode(true);
      firstClone.classList.add('clone');
      const lastClone = slides[slides.length - 1].cloneNode(true);
      lastClone.classList.add('clone');

      carousel.appendChild(firstClone);
      carousel.insertBefore(lastClone, slides[0]);

      let allSlides = Array.from(carousel.children);
      let currentIndex = 1;
      let slideWidth = slides[0].offsetWidth;

      const updateSlidePosition = (withTransition = true) => {
          if (withTransition) {
              carousel.style.transition = 'transform 0.8s ease';
          } else {
              carousel.style.transition = 'none';
          }
          carousel.style.transform = `translateX(-${(slideWidth + 20) * currentIndex}px)`;
      };
      
      updateSlidePosition(false);

      const handleArrowClick = (direction) => {
          if (direction === 'right') {
              if (currentIndex >= allSlides.length - 1) return;
              currentIndex++;
          } else if (direction === 'left') {
              if (currentIndex <= 0) return;
              currentIndex--;
          }
          updateSlidePosition();
      };

      mobileView.querySelectorAll('.mobile-arrow').forEach(arrow => {
          arrow.addEventListener('click', function() {
              handleArrowClick(this.dataset.direction);
          });
      });

      carousel.addEventListener('transitionend', () => {
          if (allSlides[currentIndex].classList.contains('clone')) {
            if (currentIndex === 0) {
                currentIndex = allSlides.length - 2;
            } else if (currentIndex === allSlides.length - 1) {
                currentIndex = 1;
            }
            updateSlidePosition(false);
          }
      });
      
      window.addEventListener('resize', () => {
          slideWidth = slides[0].offsetWidth;
          updateSlidePosition(false);
      }, { passive: true });
      carousel.dataset.initialized = 'true';
  };

  const setupDesktopSlider = () => {
    const desktopView = document.querySelector('.desktop-view');
    if(!desktopView || window.getComputedStyle(desktopView).display === 'none') return;

    const testimonialSliders = desktopView.querySelector('.testimonial-sliders');
    if (!testimonialSliders || testimonialSliders.dataset.initialized === 'true') return;

    const arrowButtons = desktopView.querySelectorAll('.testimonial-arrows .arrow-button');
    let count = 0;
    
    arrowButtons.forEach(button => {
      button.addEventListener('click', function() {
        const direction = this.getAttribute('data-direction');
        console.log(`Desktop arrow button clicked: ${direction}`);
        if (direction === 'right') {
          slideRight();
        }
        if (direction === 'left') {
          slideLeft();
        }
      });
    });
    
    function slideRight() {
      const cards = testimonialSliders.querySelectorAll('.testimonial-card');
      if (count >= cards.length - 1) return;

      const currentCard = cards[count];
      const shiftAmount = currentCard.offsetWidth + 20;

      const currentCardShift = parseFloat(currentCard.dataset.shift) || 0;
      currentCard.classList.add('shrunk');
      currentCard.style.transition = 'transform 0.4s ease';
      currentCard.style.transform = `translateX(${currentCardShift}px) scale(0)`;

      for (let i = count + 1; i < cards.length; i++) {
        const card = cards[i];
        const previousShift = parseFloat(card.dataset.shift) || 0;
        const newShift = previousShift - shiftAmount;
        card.dataset.shift = newShift;
        card.style.transition = 'transform 0.4s ease';
        const scalePart = card.classList.contains('shrunk') ? ' scale(0)' : '';
        card.style.transform = `translateX(${newShift}px)${scalePart}`;
      }
      count += 1;
    }

    function slideLeft() {
      const cards = testimonialSliders.querySelectorAll('.testimonial-card');
      if (count <= 0) return;
      count -= 1;
      const currentCard = cards[count];

      const shiftAmount = currentCard.offsetWidth + 20;
      const currentCardShift = parseFloat(currentCard.dataset.shift) || 0;
      currentCard.classList.remove('shrunk');
      currentCard.style.transition = 'transform 0.4s ease';
      currentCard.style.transform = `translateX(${currentCardShift}px) scale(1)`;

      for (let i = count + 1; i < cards.length; i++) {
        const card = cards[i];
        const previousShift = parseFloat(card.dataset.shift) || 0;
        const newShift = previousShift + shiftAmount;
        card.dataset.shift = newShift;
        card.style.transition = 'transform 0.4s ease';
        const scalePart = card.classList.contains('shrunk') ? ' scale(0)' : '';
        card.style.transform = `translateX(${newShift}px)${scalePart}`;
      }
    }
    testimonialSliders.dataset.initialized = 'true';
  }

  const initSliders = () => {
    setupMobileCarousel();
    setupDesktopSlider();
  }

  const observer = new MutationObserver(initSliders);
  const desktopViewNode = document.querySelector('.desktop-view');
  const mobileViewNode = document.querySelector('.mobile-view');
  
  if (mobileViewNode) observer.observe(mobileViewNode, { attributes: true, attributeFilter: ['style', 'class'] });
  if (desktopViewNode) observer.observe(desktopViewNode, { attributes: true, attributeFilter: ['style', 'class'] });

  initSliders();
 
});

  } catch(e) { console.error(e); }
})();
})();
